module.exports = "/assets/data/27ff25c2b59f2fb2b8420b1fe04107f6-WS14.data.json";